module.exports = __webpack_public_path__ + "assets/img/3_1215.af4d99f6.jpg";